// src/components/DiscountBridge.js
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, doc, updateDoc, limit, increment } from 'firebase/firestore';
import { db } from '../firebase';

const DiscountBridge = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if we're coming from the Mother's Day page with a discount parameter
    const searchParams = new URLSearchParams(location.search);
    const discount = searchParams.get('discount');
    
    if (discount === 'MOM2025') {
      // Store the discount code in localStorage so it persists throughout the order process
      localStorage.setItem('activeDiscount', discount);
      
      // Create a cleaner URL by removing the discount parameter
      const newUrl = location.pathname;
      navigate(newUrl, { replace: true });
      
      // Optionally display a toast or notification that the discount has been applied
      if (window.showDiscountToast) {
        window.showDiscountToast('50% Mother\'s Day discount applied!');
      }
    } else {
      // Check if there's a stored discount code
      const storedDiscount = localStorage.getItem('activeDiscount');
      if (storedDiscount && location.pathname === '/packages') {
        // Optionally display a reminder toast that a discount is active
        if (window.showDiscountToast) {
          window.showDiscountToast('50% Mother\'s Day discount active!');
        }
      }
    }
  }, [location, navigate]);

  // This is a utility component that doesn't render anything visual
  return null;
};

// Helper function to apply discount in checkout
export const applyStoredDiscount = async (discountCode) => {
  if (!discountCode) return { applied: false, amount: 0 };
  
  try {
    // Query for the discount code
    const discountsRef = collection(db, 'discounts');
    const q = query(
      discountsRef, 
      where('code', '==', discountCode),
      where('isActive', '==', true),
      limit(1)
    );
    
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      return { applied: false, amount: 0 };
    }
    
    const discountData = querySnapshot.docs[0].data();
    const discountId = querySnapshot.docs[0].id;
    
    // Check if discount is valid
    if (discountData.expirationDate && new Date() > new Date(discountData.expirationDate.seconds * 1000)) {
      return { applied: false, amount: 0, reason: 'expired' };
    }
    
    if (discountData.usageLimit && discountData.usageCount >= discountData.usageLimit) {
      return { applied: false, amount: 0, reason: 'limit_reached' };
    }
    
    return { 
      applied: true, 
      amount: discountData.value, 
      id: discountId,
      code: discountCode
    };
  } catch (error) {
    console.error('Error applying discount:', error);
    return { applied: false, amount: 0, error: true };
  }
};

export default DiscountBridge;